import { useQuery } from '@tanstack/react-query';

import { SearchRelationshipsContactParams, SearchRelationshipsOimContactParams, useRelationshipsApiProxyService } from './relationships-api-proxy.service';

const relationshipsApiProxyOimContactApiKey = 'relationships-api-proxy-oim-contact';
const relationshipsApiProxyContactApiKey = 'relationships-api-proxy-contact';

export const useSearchRelationshipsOimContact = (params: SearchRelationshipsOimContactParams) => {
  const service = useRelationshipsApiProxyService();

  return useQuery({
    queryKey: [relationshipsApiProxyOimContactApiKey, params],
    queryFn: () => service.searchRelationshipsOimContact(params),
    enabled: false,
  });
}

export const useSearchRelationshipsContact = (params: SearchRelationshipsContactParams) => {
  const service = useRelationshipsApiProxyService();

  return useQuery({
    queryKey: [relationshipsApiProxyContactApiKey, params],
    queryFn: () => service.searchRelationshipsContact(params),
    enabled: false,
  });
}
